import { render, staticRenderFns } from "./BookingTabsFinancials.vue?vue&type=template&id=805a6afa&scoped=true&"
import script from "./BookingTabsFinancials.vue?vue&type=script&lang=js&"
export * from "./BookingTabsFinancials.vue?vue&type=script&lang=js&"
import style0 from "./BookingTabsFinancials.vue?vue&type=style&index=0&id=805a6afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805a6afa",
  null
  
)

export default component.exports